import React, { useState } from 'react';
import { Card } from './ui/card';

const Products = () => {
  const products = [
    {
      id: 1,
      name: 'Oxtail',
      description: 'With Red Beans and Rice and Steam Cabbages',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/qzragdya_3-Oxtail.jpg',
      category: 'Beef',
      tags: ['Premium', 'Rich Flavor'],
      details: 'Oxtail is bone-in beef derived from the tail of the cattle/Bovine Species. This muscle is sliced between ½"-3/4", seasoned with an array of spices and seasonings. Slowly cooked until falling off the bone in a brown gravy. Especially good over red beans and rice, with steamed cabbage. This item is one of the most preferred/loved Caribbean dishes.'
    },
    {
      id: 2,
      name: 'Curry Chicken',
      description: 'With Steam Rice',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/iv6qga6t_6-Curry-Chicken.jpg',
      category: 'Chicken',
      tags: ['Aromatic', 'Flavorful'],
      details: 'Boneless, skinless dark and white meat of the chicken, cut in small pieces, seasoned with items such as real garlic cloves, scallion, thyme leaves, and allspice combined with other spices to produce a unique flavor. This is a popular item that family and friends of the family speak very highly of.'
    },
    {
      id: 3,
      name: 'Jerk Chicken',
      description: 'With Red Beans and Rice',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/xonctslq_4-Jerk-Chicken.jpg',
      category: 'Chicken',
      tags: ['Spicy', 'Popular'],
      details: 'Bone-in chicken parts (Avian Species) seasoned with an array of seasonings, particularly natural herbs. Cooked over a charcoal grill until completely done.'
    },
    {
      id: 4,
      name: 'Jerk Pork',
      description: 'Served with Red Beans and Rice',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/2ir2qwgf_1-Jerk-Pork.jpg',
      category: 'Pork',
      tags: ['Spicy', 'Traditional'],
      details: 'Boneless pork (Porcine Specie) shoulder with fat and or skin-on. Season with a blend of natural seasoning and herbs. Cooked over a charcoal grill until completely done.'
    },
    {
      id: 5,
      name: 'Stew Chicken',
      description: 'With Steam Rice',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/gwdia9lq_2-Stew-Chicken.jpg',
      category: 'Chicken',
      tags: ['Savory', 'Comfort Food'],
      details: 'Skinless bone-in chicken (Avian Species), seasoned with an array of seasonings, lightly browned in a fryer, drained, and simmered in gravy with vegetables included.'
    },
    {
      id: 6,
      name: 'Vegetarian Choice',
      description: 'Steam Rice with Split Peas Dhaul',
      image: 'https://customer-assets.emergentagent.com/job_authentic-meals/artifacts/nh2azfzw_5-Vegetarian.jpg',
      category: 'Vegetarian',
      tags: ['Healthy', 'Plant-Based'],
      details: 'The vegetarian meal is made from the yellow split peas, typically served over steamed white rice.'
    }
  ];

  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Chicken', 'Pork', 'Beef', 'Vegetarian'];

  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  return (
    <section id="products" className="products-section">
      <div className="products-container">
        <div className="section-header">
          <span className="section-badge">Our Menu</span>
          <h2 className="section-title">Caribbean-Style Frozen Dinners</h2>
          <p className="section-description">
            Each meal is crafted with authentic Caribbean recipes, prepared with love, 
            and frozen to lock in freshness and flavor.
          </p>
        </div>

        <div className="category-filter">
          {categories.map((category) => (
            <button
              key={category}
              className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="products-grid">
          {filteredProducts.map((product, index) => (
            <Card key={product.id} className="product-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="product-image-wrapper">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="product-image"
                />
                <div className="product-tags">
                  {product.tags.map((tag, i) => (
                    <span key={i} className="product-tag">{tag}</span>
                  ))}
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                {product.details && (
                  <p className="product-details">{product.details}</p>
                )}
                <div className="product-footer">
                  <span className="product-category">{product.category}</span>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="products-cta">
          <div className="cta-box">
            <h3>Nutritious Meals, Conveniently Delivered</h3>
            <p>All products are produced under USDA Food Safety guidelines, ensuring quality and safety in every bite.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
